import { gql } from '@apollo/client'

import { BILLING_PERIOD_FRAGMENT } from './BillingPeriodFragment'
import { PAYMENT_METHOD_FRAGMENT } from './PaymentMethodFragment'

export const SUBSCRIPTION_INFO_FRAGMENT = gql`
  fragment SubscriptionInfo on SubscriptionInfo {
    planType
    nextPlanType
    id
    planId
    customerId
    unitQuantity
    centsPerUnit
    monthlySubtotal
    cancelAt
    trialEnd
    paymentMethod {
      ...PaymentMethod
    }
    billingPeriod {
      ...BillingPeriod
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
  ${BILLING_PERIOD_FRAGMENT}
`
